import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { breakpointCodes } from 'rp-mq-breakpoints';
import { PagerDefault as Pager } from 'rp-react-pagination';
import DataTable from '../GridDataTable';
import RelativesRow from '../../components/DataTable/RelativesRow';
import ShortlistTableActions from './ShortlistTableActions';
import ShortlistTableNote from './ShortlistTableNote';
import TableBody from '../../components/DataTable/ExpandableRowsBody';
import tableConfig from '../../config/shortlistTable';
import { expandRow } from '../../actions/expandableRow';
import { selectRow, selectRows, deleteRows } from '../../modules/DataTable/actions';
import {
    withProps,
    shortlistStateKey,
    shortlistPagerLength,
    isRefinementUsed
} from '../../helpers/shortlistUtils';
import * as shortlistActions from '../../actions/shortlist';

const { EXTRA_NARROW, NARROW } = breakpointCodes;
const SHOW_SHORTLIST = false;

class ShortlistTable extends PureComponent {
    static propTypes = {
        selectedRows: PropTypes.array.isRequired,
        updateShortlistTable: PropTypes.func.isRequired,
        onRowSelect: PropTypes.func.isRequired,
        onRowsSelect: PropTypes.func.isRequired,
        onRowDelete: PropTypes.func.isRequired,
        breakpointCode: PropTypes.string.isRequired
    };

    static colSpanGetter = (breakpoint) => {
        switch (breakpoint) {
            case EXTRA_NARROW:
                return 5;
            case NARROW:
                return 6;
            default:
                return 11;
        }
    };

    expansionComponent = withProps(RelativesRow, (ownProps) => ({
        showShortlist: SHOW_SHORTLIST,
        colSpan: ShortlistTable.colSpanGetter(this.props.breakpointCode),
        venueId: ownProps.data.venue_uid,
        saleDate: ownProps.data.sale_date,
        saleEndDate: ownProps.data.sale_date,
        className: 'table__SalesShortlistRelatives',
        damDateOfBirth: ownProps.data.dam_date_of_birth,
        ...ownProps.data,
    }));

    getTableProps() {
        return {
            bodyComponent: TableBody,
            bodyProps: {
                expansionComponent: this.expansionComponent,
                expandedRow: this.props.expandedRow,
                onRowExpand: this.props.onRowExpand,
                onRowSelect: this.props.onRowSelect,
                primaryColumn: 'lot_no',
                identity: ({
                    lot_no,
                    sale_date,
                    sale_name,
                    venue_uid,
                    lot_letter,
                }) => ({
                    lot_no,
                    sale_date,
                    sale_name,
                    venue_uid,
                    lot_letter,
                })
            },
            headerProps: {
                onRowsSelect: this.props.onRowsSelect
            }
        };
    }

    createErrorMessage = () => {
        const ERROR_MESSAGE_DEFAULT = 'You currently have no horses added to your Shortlist';
        const ERROR_MESSAGE_REFINE = 'No lots found matching your search. ' +
            'Use the reset button to clear your search and start again';

        if (isRefinementUsed(this.props.refinement)) {
            return ERROR_MESSAGE_REFINE;
        }
        return ERROR_MESSAGE_DEFAULT;
    };

    render() {
        const errorMessage = this.createErrorMessage();
        return (
            <div>
                <div className="table__SalesSearch table__SalesSearch_shortlist">
                    <DataTable
                        config={tableConfig}
                        tableProps={this.getTableProps()}
                        stateKey={shortlistStateKey}
                        errorMessage={errorMessage}
                        colSpanGetter={ShortlistTable.colSpanGetter}
                    />
                    <ShortlistTableActions
                        selectedRows={this.props.selectedRows}
                        onRowDelete={this.props.onRowDelete}
                    />
                    <Pager
                        onPageChange={this.props.updateShortlistTable}
                        stateKey={shortlistStateKey}
                        pageSize={50}
                        pagerLength={shortlistPagerLength}
                        offsetRange={5}
                    />
                    <ShortlistTableNote />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const activeSwitch = state.relativesSwitcher.activeIndex;
    const {
        refinement,
        dataTable: { selectedRows },
        pager,
        expandableRow: {
            expandedRow
        }
    } = state[shortlistStateKey];
    const breakpointCode = state.breakpoints.current.code;
    return {
        refinement,
        selectedRows,
        pager,
        expandedRow,
        activeSwitch,
        breakpointCode,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(shortlistActions, dispatch),
        onRowExpand(rowKey) {
            dispatch(expandRow(shortlistStateKey, rowKey));
        },
        onRowSelect(row) {
            dispatch(selectRow(shortlistStateKey, row));
        },
        onRowsSelect() {
            dispatch(selectRows(shortlistStateKey));
        },
        onRowDelete(selectedRows) {
            return dispatch(deleteRows(shortlistStateKey, selectedRows));
        }
    };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return Object.assign(
        {},
        stateProps,
        dispatchProps,
        ownProps,
        {
            onRowDelete() {
                dispatchProps.onRowDelete(stateProps.selectedRows)
                    .then(() => dispatchProps.updateShortlistTable());
            }
        }
    );
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ShortlistTable);



// WEBPACK FOOTER //
// ./src/js/containers/Shortlist/ShortlistTable.js